import React, { Suspense, useMemo } from "react";
import { Box } from "@mui/material";
import { useApplicationContext } from "../context/ApplicationContext";
import ClaimsWebComponent from './ClaimsWebcomponent';
import MemberWebComponent from './MemberWebcomponent';

const RenderComponent: React.FC = () => {
  const { activeView, getContextString, getContextStringLite } = useApplicationContext();

  const component = activeView?.component as string | undefined;

  const claimsContext = useMemo(() => getContextString(), [getContextString]);
  const memberContext = useMemo(() => getContextStringLite(), [getContextStringLite]);

  if (!component) return null;

  return (
    <Box sx={{ pt: "50px" }}>
      <Suspense fallback={null}>
        {component === "claims" && <ClaimsWebComponent context={claimsContext} />}
        {component === "member" && <MemberWebComponent context={memberContext} />}
      </Suspense>
    </Box>
  );
};

export default RenderComponent;
